angular.module('main').directive('btnDelete', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText',
		snEmpty: '@'
	},
	template: ` <button class="btn btn-default">
                        <i class="fa fa-trash-o" ng-if="snEmpty"></i>
                        <i class="fi fa fa-trash-o" ng-if="!snEmpty"></i>
                        {{text}}
                    </button>`,
	replace: true,
	transclude: true
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnDelete.js